module.exports = __webpack_public_path__ + "img/Barcelona.1ae6f61d.png";